var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _g7, _path11, _path12, _path13, _g8, _path14, _path15, _g9, _path16, _path17, _g10, _path18, _g11, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g12, _path29, _g13, _path30, _g14, _path31, _g15, _path32, _path33, _g16, _path34, _g17, _path35, _path36, _g18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5467_6377)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 -9.25781H-10V110.742H110V-9.25781Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 -9.25781H-10V110.742H110V-9.25781Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 74,
    width: 10,
    height: 3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6182 74.9512H47.2307V76.3483H38.6182V74.9512Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.3809,
    y: 78.8906,
    width: 23.8595,
    height: 11.2896,
    transform: "rotate(-90 38.3809 78.8906)",
    fill: "url(#pattern0_5467_6377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 1,
    width: 79,
    height: 80
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2188 1.69531H88.7807V80.2572H10.2188V1.69531Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5467_6377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.8004 40.9864C88.8004 41.6292 88.7845 42.2721 88.7532 42.9144C88.7218 43.5563 88.6741 44.1977 88.6114 44.8377C88.5482 45.4776 88.4696 46.1156 88.3751 46.7517C88.2811 47.3878 88.1711 48.021 88.0457 48.6518C87.9199 49.2821 87.779 49.9095 87.6228 50.5331C87.4665 51.1571 87.2953 51.7768 87.1087 52.3922C86.9221 53.0075 86.7205 53.6176 86.5035 54.2233C86.2869 54.8285 86.0559 55.4284 85.8095 56.0226C85.5636 56.6162 85.3031 57.2041 85.0283 57.7852C84.7534 58.3668 84.464 58.9407 84.1612 59.5078C83.8578 60.0749 83.541 60.6344 83.2106 61.1861C82.8798 61.7373 82.536 62.2808 82.1786 62.8151C81.8218 63.3499 81.4514 63.8756 81.0685 64.3921C80.6851 64.9086 80.2896 65.4154 79.8817 65.9121C79.4742 66.4093 79.0541 66.8959 78.622 67.3724C78.1904 67.8489 77.7472 68.3147 77.2924 68.7695C76.8377 69.2238 76.3723 69.6674 75.8958 70.0991C75.4194 70.5307 74.9328 70.9507 74.4356 71.3587C73.9384 71.7667 73.4315 72.1621 72.915 72.545C72.3985 72.9284 71.8729 73.2983 71.3385 73.6557C70.8037 74.013 70.2607 74.3569 69.709 74.6872C69.1578 75.018 68.5984 75.3349 68.0312 75.6377C67.4641 75.9411 66.8898 76.2299 66.3086 76.5048C65.7275 76.7797 65.1397 77.0406 64.5455 77.2866C63.9514 77.5325 63.3515 77.764 62.7462 77.9805C62.141 78.1971 61.5305 78.3986 60.9151 78.5853C60.2998 78.7719 59.6801 78.9436 59.0565 79.0998C58.4325 79.2561 57.8056 79.3969 57.1748 79.5223C56.544 79.6477 55.9108 79.7576 55.2747 79.8521C54.6386 79.9462 54.0006 80.0253 53.3606 80.088C52.7207 80.1511 52.0798 80.1984 51.4374 80.2302C50.795 80.2616 50.1527 80.2775 49.5094 80.2775C48.8665 80.2775 48.2237 80.2616 47.5818 80.2302C46.9394 80.1984 46.2985 80.1511 45.6586 80.088C45.0186 80.0253 44.3806 79.9462 43.7445 79.8521C43.1084 79.7576 42.4747 79.6477 41.8444 79.5223C41.2136 79.3969 40.5862 79.2561 39.9627 79.0998C39.3391 78.9436 38.7194 78.7719 38.1041 78.5853C37.4887 78.3986 36.8782 78.1971 36.273 77.9805C35.6672 77.764 35.0678 77.5325 34.4737 77.2866C33.8795 77.0406 33.2917 76.7797 32.7106 76.5048C32.1294 76.2299 31.5551 75.9411 30.9879 75.6377C30.4208 75.3349 29.8614 75.018 29.3102 74.6872C28.7585 74.3569 28.2155 74.013 27.6807 73.6557C27.1458 73.2983 26.6207 72.9284 26.1042 72.545C25.5877 72.1621 25.0808 71.7667 24.5836 71.3587C24.0864 70.9507 23.5998 70.5307 23.1234 70.0991C22.6469 69.6674 22.1815 69.2238 21.7268 68.7695C21.272 68.3147 20.8288 67.8489 20.3967 67.3724C19.9651 66.8959 19.545 66.4093 19.1371 65.9121C18.7296 65.4154 18.3336 64.9086 17.9507 64.3921C17.5678 63.8756 17.1974 63.3499 16.8406 62.8151C16.4832 62.2808 16.1394 61.7373 15.8085 61.1861C15.4782 60.6344 15.1614 60.0749 14.858 59.5078C14.5552 58.9407 14.2658 58.3668 13.9909 57.7852C13.716 57.2041 13.4556 56.6162 13.2097 56.0226C12.9633 55.4284 12.7323 54.8285 12.5152 54.2233C12.2987 53.6176 12.0971 53.007 11.9105 52.3922C11.7239 51.7768 11.5522 51.1571 11.3959 50.5331C11.2397 49.9095 11.0989 49.2821 10.9735 48.6518C10.8481 48.021 10.7381 47.3878 10.6441 46.7517C10.5496 46.1156 10.471 45.4776 10.4078 44.8377C10.3446 44.1977 10.2974 43.5563 10.266 42.9144C10.2342 42.2721 10.2188 41.6292 10.2188 40.9864C10.2188 40.3436 10.2342 39.7007 10.266 39.0584C10.2974 38.416 10.3446 37.7751 10.4078 37.1351C10.471 36.4952 10.5496 35.8572 10.6441 35.2211C10.7381 34.585 10.8481 33.9518 10.9735 33.321C11.0989 32.6907 11.2397 32.0633 11.3959 31.4392C11.5522 30.8157 11.7239 30.196 11.9105 29.5806C12.0971 28.9653 12.2987 28.3552 12.5152 27.7495C12.7323 27.1443 12.9633 26.5444 13.2097 25.9502C13.4556 25.3561 13.716 24.7687 13.9909 24.1876C14.2658 23.606 14.5552 23.0316 14.858 22.465C15.1614 21.8979 15.4782 21.3384 15.8085 20.7867C16.1394 20.2351 16.4832 19.692 16.8406 19.1577C17.1974 18.6229 17.5678 18.0972 17.9507 17.5807C18.3336 17.0642 18.7296 16.5574 19.1371 16.0607C19.545 15.5635 19.9651 15.0769 20.3967 14.6004C20.8288 14.1239 21.272 13.6581 21.7268 13.2033C22.1815 12.749 22.6469 12.3054 23.1234 11.8737C23.5998 11.4421 24.0864 11.0221 24.5836 10.6141C25.0808 10.2061 25.5877 9.81067 26.1042 9.42776C26.6207 9.04437 27.1458 8.67448 27.6807 8.31713C28.2155 7.95978 28.7585 7.61593 29.3102 7.28559C29.8614 6.95476 30.4208 6.63792 30.9879 6.33507C31.5551 6.03173 32.1294 5.74286 32.7106 5.46798C33.2917 5.19309 33.8795 4.9322 34.4737 4.68625C35.0678 4.4403 35.6672 4.20882 36.273 3.99228C36.8782 3.77575 37.4887 3.57417 38.1041 3.38754C38.7194 3.20042 39.3391 3.02922 39.9627 2.87297C40.5862 2.71672 41.2136 2.57591 41.8444 2.45052C42.4747 2.32513 43.1084 2.21518 43.7445 2.12066C44.3806 2.02662 45.0186 1.94753 45.6586 1.88484C46.2985 1.82166 46.9394 1.7744 47.5818 1.74257C48.2237 1.71123 48.8665 1.69531 49.5094 1.69531C50.1527 1.69531 50.795 1.71123 51.4374 1.74257C52.0798 1.7744 52.7207 1.82166 53.3606 1.88484C54.0006 1.94753 54.6386 2.02662 55.2747 2.12066C55.9108 2.21518 56.544 2.32513 57.1748 2.45052C57.8056 2.57591 58.4325 2.71672 59.0565 2.87297C59.6801 3.02922 60.2998 3.20042 60.9151 3.38754C61.5305 3.57417 62.141 3.77575 62.7462 3.99228C63.3519 4.20882 63.9514 4.4403 64.5455 4.68625C65.1397 4.9322 65.7275 5.19309 66.3086 5.46798C66.8898 5.74286 67.4641 6.03173 68.0312 6.33507C68.5984 6.63792 69.1578 6.95476 69.709 7.28559C70.2607 7.61593 70.8037 7.95978 71.3385 8.31713C71.8729 8.67448 72.3985 9.04437 72.915 9.42776C73.4315 9.81067 73.9384 10.2061 74.4356 10.6141C74.9328 11.0221 75.4194 11.4421 75.8958 11.8737C76.3723 12.3054 76.8377 12.749 77.2924 13.2033C77.7472 13.6581 78.1904 14.1239 78.622 14.6004C79.0541 15.0769 79.4742 15.5635 79.8817 16.0607C80.2896 16.5574 80.6851 17.0642 81.0685 17.5807C81.4514 18.0972 81.8218 18.6229 82.1786 19.1577C82.536 19.692 82.8798 20.2351 83.2106 20.7867C83.541 21.3384 83.8578 21.8979 84.1612 22.465C84.464 23.0316 84.7534 23.606 85.0283 24.1876C85.3031 24.7687 85.5636 25.3561 85.8095 25.9502C86.0559 26.5444 86.2869 27.1443 86.5035 27.7495C86.7205 28.3552 86.9221 28.9653 87.1087 29.5806C87.2953 30.196 87.4665 30.8157 87.6228 31.4392C87.779 32.0633 87.9199 32.6907 88.0457 33.321C88.1711 33.9518 88.2811 34.585 88.3751 35.2211C88.4696 35.8572 88.5482 36.4952 88.6114 37.1351C88.6741 37.7751 88.7218 38.416 88.7532 39.0584C88.7845 39.7007 88.8004 40.3436 88.8004 40.9864Z",
    fill: "#1155CC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 7,
    width: 67,
    height: 68
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0117 7.83398H83.3336V74.1751H17.0117V7.83398Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5467_6377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1632 7.83398C31.8473 7.83398 17.0117 22.6691 17.0117 40.9855C17.0117 59.3015 31.8473 74.137 50.1632 74.137C68.4792 74.137 83.3148 59.3015 83.3148 40.9855C83.3148 22.6691 68.4792 7.83398 50.1632 7.83398ZM50.1632 67.5065C35.5105 67.5065 23.6422 55.6383 23.6422 40.9855C23.6422 26.3322 35.5105 14.464 50.1632 14.464C64.816 14.464 76.6843 26.3322 76.6843 40.9855C76.6843 55.6383 64.816 67.5065 50.1632 67.5065Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8066 40.9863H71.4848",
    stroke: "white",
    strokeWidth: 6.51772
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 10,
    width: 17,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9346 10.2148H42.8798V16.8492H26.9346V10.2148Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.541,
    y: 0.599609,
    width: 43.5291,
    height: 36.5458,
    fill: "url(#pattern1_5467_6377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 7,
    width: 22,
    height: 10
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.543 7.83398H50.0272V16.9119H29.543V7.83398Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.542,
    y: -1.08984,
    width: 43.5291,
    height: 36.5458,
    fill: "url(#pattern2_5467_6377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 62,
    width: 20,
    height: 8
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 62.7461H42.9665V69.38H23.2969V62.7461Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.90332,
    y: 53.1309,
    width: 43.5291,
    height: 36.5458,
    fill: "url(#pattern3_5467_6377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 66,
    width: 18,
    height: 10
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.998 66.5312H49.4086V75.7259H32.998V66.5312Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.6045,
    y: 56.916,
    width: 43.5291,
    height: 36.5458,
    fill: "url(#pattern4_5467_6377)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8544 7.71875L46.1768 74.0758",
    stroke: "white",
    strokeWidth: 6.51772
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 45,
    width: 28,
    height: 28
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.333 45.1875H80.8639V72.5949H53.333V45.1875Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_5467_6377)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 45,
    width: 28,
    height: 28
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.748 45.2852L80.774 59.6558L65.421 72.5026L53.3955 58.1319L68.748 45.2852Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.624,
    y: 14.6055,
    width: 62.1512,
    height: 52.2582,
    transform: "rotate(50.0772 70.624 14.6055)",
    fill: "url(#pattern5_5467_6377)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 49,
    width: 27,
    height: 27
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3457 49.2598H78.0247V75.0622H52.3457V49.2598Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_5467_6377)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 49,
    width: 27,
    height: 26
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3915 49.3184L78.0145 64.3295L63.0039 74.952L52.3809 59.9414L67.3915 49.3184Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.2002,
    y: 12.3496,
    width: 66.6903,
    height: 55.9826,
    transform: "rotate(54.7137 78.2002 12.3496)",
    fill: "url(#pattern6_5467_6377)"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6689 12.3945L54.4731 74.0868",
    stroke: "white",
    strokeWidth: 6.51773
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 65,
    width: 4,
    height: 4
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8857 65.0391H39.679V68.0652H36.8857V65.0391Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.5898,
    y: 62.0898,
    width: 13.3846,
    height: 11.1732,
    fill: "url(#pattern7_5467_6377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 13,
    width: 17,
    height: 8
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 13.5215H39.0092V20.1554H23.2969V13.5215Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.41406,
    y: 3.90625,
    width: 43.5291,
    height: 36.5458,
    fill: "url(#pattern8_5467_6377)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3401 72.3157L10.518 78.6814L8.96707 76.7775L12.1866 74.1579L9.7734 71.193L6.55388 73.8126L5.00488 71.9068L12.827 65.541L14.376 67.4469L11.3108 69.9411L13.724 72.906L16.7892 70.4118L18.3401 72.3157Z",
    fill: "#1155CC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4971 85.2526L18.4029 83.1056L16.8906 84.2264L14.7783 82.7603L23.5264 76.5547L25.8644 78.177L23.1097 88.5435L20.9743 87.0601L21.4971 85.2526ZM22.0565 83.3332L23.1348 79.589L20.0137 81.9154L22.0565 83.3332Z",
    fill: "#1155CC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6395 86.1982C29.953 85.2544 30.4372 84.4804 31.0921 83.8756C31.7479 83.2699 32.5104 82.8822 33.3799 82.7124C34.2489 82.5417 35.1473 82.6102 36.0747 82.9188C37.2099 83.296 38.0828 83.919 38.6924 84.788C39.3029 85.6576 39.572 86.6553 39.4987 87.7819L36.937 86.9293C36.8777 86.4653 36.7079 86.0708 36.4277 85.7468C36.1471 85.4217 35.7844 85.1849 35.3398 85.0369C34.6222 84.7977 33.9571 84.8546 33.3452 85.2066C32.7341 85.5577 32.29 86.1514 32.0122 86.9871C31.733 87.8243 31.733 88.567 32.0122 89.2151C32.2924 89.8623 32.7915 90.305 33.5091 90.5442C33.9538 90.6923 34.3859 90.7198 34.8054 90.6272C35.2245 90.5346 35.5963 90.3195 35.9204 89.981L38.4821 90.8336C37.8658 91.7812 37.0537 92.4178 36.0458 92.7433C35.0388 93.0683 33.9673 93.0428 32.832 92.6661C31.9047 92.3575 31.1442 91.8743 30.55 91.2174C29.9559 90.5606 29.5764 89.7958 29.4119 88.9239C29.2484 88.0519 29.3241 87.1434 29.6395 86.1982Z",
    fill: "#1155CC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4407 95.3847L46.2366 90.7936L46.0514 95.2439L43.5996 95.1416L44.0182 85.0664L46.47 85.1686L46.2867 89.588L49.8303 85.3075L52.7161 85.4271L48.6035 90.2014L52.4422 95.5082L49.4407 95.3847Z",
    fill: "#1155CC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5339 83.6016L62.939 85.5267L58.917 86.3716L59.3549 88.4511L62.3642 87.8203L62.7558 89.6915L59.7465 90.3222L60.5856 94.3153L58.1821 94.8207L56.1084 84.9519L62.5339 83.6016Z",
    fill: "#1155CC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8092 89.3761L71.2676 86.8568L70.7352 87.1134L72.3883 90.5432L70.1758 91.608L65.7988 82.5223L69.5122 80.7341C70.2298 80.3884 70.9011 80.2191 71.5261 80.2268C72.1511 80.2336 72.6936 80.3942 73.1542 80.7091C73.6142 81.0245 73.973 81.4493 74.2305 81.9841C74.5209 82.5874 74.6106 83.2086 74.4987 83.8476C74.3868 84.487 74.0458 85.0657 73.4763 85.5837L77.3073 88.1724L74.8092 89.3761ZM69.9809 85.547L71.3544 84.8854C71.7595 84.6901 72.0151 84.4446 72.1221 84.1485C72.2287 83.8514 72.1954 83.5225 72.0218 83.1608C71.8545 82.8151 71.6216 82.5918 71.3235 82.4915C71.025 82.3902 70.6734 82.437 70.2683 82.6323L68.8949 83.2939L69.9809 85.547Z",
    fill: "#1155CC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0339 76.9866L80.3321 78.5587L82.8688 76.4638L84.0764 77.928L81.5397 80.0229L82.9498 81.7281L85.8183 79.3593L87.0702 80.8774L82.3074 84.8107L75.8877 77.0348L80.6504 73.1016L81.9024 74.6178L79.0339 76.9866Z",
    fill: "#1155CC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3446 69.5927L87.9611 70.8349L89.9673 68.225L91.4719 69.3824L89.4658 71.9924L91.2192 73.3407L93.4878 70.3913L95.0483 71.5911L91.2829 76.487L83.2891 70.3392L87.0545 65.4434L88.6131 66.6432L86.3446 69.5927Z",
    fill: "#1155CC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 68,
    width: 11,
    height: 7
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6543 68.6426H67.4074V74.8154H57.6543V68.6426Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_5467_6377)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 68,
    width: 11,
    height: 7
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7165 68.7285L67.3765 68.7623L67.3553 74.8145L57.6953 74.7803L57.7165 68.7285Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.4463,
    y: 60.3359,
    width: 38.7572,
    height: 32.5886,
    transform: "rotate(0.201042 46.4463 60.3359)",
    fill: "url(#pattern9_5467_6377)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 67,
    width: 3,
    height: 8
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5098 67.3164H51.2555V74.882H49.5098V67.3164Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.1162,
    y: 57.7012,
    width: 43.5291,
    height: 36.5458,
    fill: "url(#pattern10_5467_6377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 69,
    width: 3,
    height: 8
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5098 69.3594H51.2555V76.925H49.5098V69.3594Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.3926,
    y: 59.7441,
    width: 43.5291,
    height: 36.5458,
    fill: "url(#pattern11_5467_6377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 7,
    width: 2,
    height: 9
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0322 7.7168H51.3126V15.2824H50.0322V7.7168Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.6064,
    y: -1.89844,
    width: 43.5291,
    height: 36.5458,
    fill: "url(#pattern12_5467_6377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 40,
    width: 21,
    height: 21
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M66.543 40.8652H86.543V60.9887H66.543V40.8652Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_5467_6377)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 40,
    width: 21,
    height: 21
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5962 40.9863L86.4722 50.8619L76.4317 60.9024L66.5557 51.0268L76.5962 40.9863Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.7891,
    y: 11.1953,
    width: 51.5599,
    height: 43.2963,
    transform: "rotate(45 79.7891 11.1953)",
    fill: "url(#pattern13_5467_6377)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 3,
    width: 10,
    height: 5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4072 3.83398H50.951V7.79087H41.4072V3.83398Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.0078,
    y: -1.98242,
    width: 26.3037,
    height: 22.1137,
    fill: "url(#pattern14_5467_6377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 66,
    width: 11,
    height: 7
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6543 66.4219H67.4074V72.5947H57.6543V66.4219Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_5467_6377)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_5467_6377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 66,
    width: 11,
    height: 7
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M57.737 66.4746L67.3971 66.5084L67.3758 72.5606L57.7158 72.5264L57.737 66.4746Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_5467_6377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.4658,
    y: 58.082,
    width: 38.7572,
    height: 32.5886,
    transform: "rotate(0.201042 46.4658 58.082)",
    fill: "url(#pattern15_5467_6377)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5467_6377",
    transform: "scale(0.00268097 0.00568182)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern8_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern9_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern10_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern11_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern12_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern13_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern14_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern15_5467_6377",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_5467_6377",
    transform: "scale(0.00943396 0.011236)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5467_6377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0 0.742188)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5467_6377",
    width: 373,
    height: 176,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXUAAACwCAIAAAB/zWksAAAABmJLR0QA/wD/AP+gvaeTAAACRklEQVR4nO3UQQ3AIADAQEAVyrHHVDQky52Cvjr3uQMgsF4HAL/lL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWofK1wA01UDs33AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_5467_6377",
    width: 106,
    height: 89,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackLogo);
export default __webpack_public_path__ + "static/media/feedback-logo.0223bc1491a19b64d0f4e36443f1cd5a.svg";
export { ForwardRef as ReactComponent };